import { ChangeEvent, useEffect, useState } from "react"
import { AddressForm } from "src/components/common/form/address/AddressForm"
import { DropDownForm } from "src/components/common/form/DropdownForm"
import { ImageForm } from "src/components/common/form/ImageForm"
import { InputForm } from "src/components/common/form/input/InputForm"
import { AddressJusoDto } from "src/dtos/address/addressApiResponseDto"
import { SysCodeDto } from "src/dtos/code/sysCodeDto"
import { SYS4010_R01Dto } from "src/containers/mes/SYS/SYS4010_R01/Dto_SYS4010_R01"
import { useCommonCodeStore } from "src/store/useCommonCodeStore"
import { useSYS4010_R01Store } from "./Store_SYS4010_R01"
import useUiuxStore from "src/store/useUiuxStore"
import { formatPhoneNumber, formatRegNo } from "src/utils/string/stringUtil"
import { handleKeyDown, syntheticEvent } from "src/utils/commonForm/commonFormUtils";

import { BRDiv } from "src/components/common/common"
import useScreenStore from "src/store/useScreenStore"

// Props 타입 정의: data는 선택된 회사 정보(선택적)
interface Props {
  data?: SYS4010_R01Dto
  defaultSYS4010_R01Row: SYS4010_R01Dto
}

// 회사 정보 입력/수정 컴포넌트
export const Info_SYS4010_R01 = ({ data, defaultSYS4010_R01Row }: Props) => {

	// zustand 스토어에서 상태 및 setter 가져오기
	const { selectedSYS4010_R01, editSYS4010_R01, setEditSYS4010_R01 } = useSYS4010_R01Store();
	const { moneyCdList, paycollectTargetList, yesNoList } = useCommonCodeStore();
	const { setAddressModalProps } = useUiuxStore();

	//입력란의 각 행의 레이아웃 스타일
	const [infoRowWrapper, setInfoRowWrapper] = useState('');

	const addressHandleFoucsId = 'addressInput3';

	// input/select 값 변경 핸들러
	const handleChange = (e: ChangeEvent<HTMLInputElement> | ChangeEvent<HTMLSelectElement>) => {
		const { name, value } = e.target;

		setEditSYS4010_R01({
			...defaultSYS4010_R01Row,
			...editSYS4010_R01,
			[name]: name === 'regNo' ? formatRegNo(value)
			: name === 'telNo' || name === 'faxNo' || name === 'taxMobile' ? formatPhoneNumber(value)
				: value
		});
	}

	// 주소 검색 버튼 클릭 시 모달 오픈
	const handleAddressSearchClick = () => {
		setAddressModalProps({
			onSelect: (data: AddressJusoDto) => {
			setEditSYS4010_R01({
				...editSYS4010_R01,
				post: data.zipNo,
				address: data.roadAddr
			})
			setAddressModalProps(undefined);
			handleKeyDown(syntheticEvent(addressHandleFoucsId), 'focus');
			}
		})
	}

	// 렌더링
	return(
		<div className="w-full h-full overflow-y-auto flex border border-gray-300">
			<div className={`
				${infoRowWrapper === '' ? 'w-[70%]' : 'w-[90%]'}
				h-full flex flex-wrap content-start p-[12px]`}>
				<InputForm title="사업장코드" 	value={editSYS4010_R01.compCd}		editable={selectedSYS4010_R01 === undefined}	name="compCd"		onChange={handleChange} />
				<InputForm title="사업장번호" 	value={editSYS4010_R01.regNo}		editable={true}								name="regNo"		onChange={handleChange} />
					<BRDiv />

				<InputForm title="상호" 		value={editSYS4010_R01.compNm} editable={true} name="compNm"		onChange={handleChange} />
				<InputForm title="상호(Full)"	value={editSYS4010_R01.compNmFull}	editable={true} 							name="compNmFull"	onChange={handleChange} />
				<InputForm title="대표자"		value={editSYS4010_R01.represent}	editable={true} 							name="represent"	onChange={handleChange} />
					<BRDiv />
				
				<DropDownForm<SysCodeDto> 
						title="기준화폐"
						data={moneyCdList}
						value={editSYS4010_R01.moneyCd}
						name="moneyCd" 
						initLabelLess={true}
						onChange={handleChange} />
				<InputForm title="업태" value={editSYS4010_R01.businessType} editable={true} name="businessType" 	onChange={handleChange} />
				<InputForm title="종목" value={editSYS4010_R01.businessClass} editable={true} name="businessClass"	onChange={handleChange} />
					<BRDiv />
				<AddressForm 
					post={editSYS4010_R01.post} address={editSYS4010_R01.address} detailAddress={editSYS4010_R01.detailAddress}
					onChange={handleChange}
					onSearchClick={handleAddressSearchClick}
					handleFoucsId={addressHandleFoucsId}
					/>
					<BRDiv />
				
				<InputForm title="전화번호" 			value={editSYS4010_R01.telNo} 		editable={true}	name="telNo" 	onChange={handleChange} />
				<InputForm title="팩스번호" 			value={editSYS4010_R01.faxNo} 		editable={true}	name="faxNo" 	onChange={handleChange} />
				<InputForm title="E-mail(세금계산서)"	value={editSYS4010_R01.taxEmail}	editable={true}	name="taxEmail" onChange={handleChange} 
					wrapperOption={{
						wrapperStyle: "w-[300px] min-w-[300px] mr-[10px] mb-[5px]",
						titleStyle: "w-[120px] min-w-[120px] text-left",
						inputStyle: "w-[180px] min-w-[180px]",
					}} />
					<BRDiv />

				<DropDownForm<SysCodeDto> title="수금기준" data={paycollectTargetList} value={editSYS4010_R01.collectTarget} name="collectTarget" initLabelLess={true} onChange={handleChange} />
				<DropDownForm<SysCodeDto> title="지불기준" data={paycollectTargetList} value={editSYS4010_R01.paymentTarget} name="paymentTarget" initLabelLess={true} onChange={handleChange} />
				<InputForm title="휴대폰(세금계산서)" value={editSYS4010_R01.taxMobile} editable={true} name="taxMobile" onChange={handleChange} 
					wrapperOption={{
						wrapperStyle: "w-[300px] min-w-[300px] mr-[10px] mb-[5px]",
						titleStyle: "w-[120px] min-w-[120px] text-left",
						inputStyle: "w-[180px] min-w-[180px]",
					}} />
					<BRDiv />

				<DropDownForm<SysCodeDto> title="예외수금기본" data={yesNoList} value={editSYS4010_R01.exceptionCollect} name="exceptionCollect" initLabelLess={true} onChange={handleChange} />
				<DropDownForm<SysCodeDto> title="예외지불기본" data={yesNoList} value={editSYS4010_R01.exceptionPayment} name="exceptionPayment" initLabelLess={true} onChange={handleChange} />
				<InputForm title="API Key" value={editSYS4010_R01.apikey} editable={true} name="apikey" onChange={handleChange} />
				<BRDiv />

				<InputForm title="비고" value={editSYS4010_R01.remark} editable={true} wrapperOption={{
					wrapperStyle: "w-[510px] min-w-[510px] mr-[10px] mb-[10px]",
					titleStyle: "w-[100px] min-w-[100px] text-left",
					inputStyle: "w-full min-w-full"
				}} name="remark" onChange={handleChange} />
			</div>
			<div className="w-[10%] h-full flex flex-col gap-[12px] pt-[12px]">
				<ImageForm title="로고" image={editSYS4010_R01.logoImage} onImageChange={(logoImage) => setEditSYS4010_R01({ ...editSYS4010_R01, logoImage })} />
				<ImageForm title="도장" image={editSYS4010_R01.signImage} onImageChange={(signImage) => setEditSYS4010_R01({ ...editSYS4010_R01, signImage })} />
			</div>
		</div>
	)
}